import React, { useContext } from 'react';
import { ThemeContext, isDarkTheme } from 'ggApp/shared/components/ThemeContext';
import PropTypes from 'prop-types';
import ReadMore from 'ggApp/shared/screens/ProductDetailsPage/ReadMore';
import { Translator } from 'ggApp/modules/translator';
import { Container, Card, Image, Label, CardGrid, Title, Shimmer } from './styles';

const WhatsInTheBox = ({ className, amountOfItems, loading, cards, nodeRef }) => {
    const theme = useContext(ThemeContext);
    const isDarkMode = isDarkTheme(theme);

    if (!amountOfItems) {
        return null;
    }

    return (
        <ReadMore className={className} refresh={cards.length}>
            <Container ref={nodeRef}>
                <Shimmer loading={loading} data-testid="Shimmer effect" />
                <Title>
                    <Translator tk="PDP_WIB_BLOCK_HEADER" />
                </Title>
                <CardGrid>
                    {[...Array(cards.length || amountOfItems)].map((_, index) => {
                        const { label, image } = cards[index] || {};
                        return (
                            // eslint-disable-next-line react/no-array-index-key
                            <Card key={index}>
                                {image && (
                                    <Image
                                        isDarkMode={isDarkMode}
                                        src={image.url}
                                        alt="Accessory image"
                                    />
                                )}
                                {label && <Label title={label}>{label}</Label>}
                            </Card>
                        );
                    })}
                </CardGrid>
            </Container>
        </ReadMore>
    );
};

WhatsInTheBox.propTypes = {
    className: PropTypes.string,
    amountOfItems: PropTypes.number.isRequired,
    loading: PropTypes.bool,
    cards: PropTypes.arrayOf(PropTypes.shape({})),
    nodeRef: PropTypes.shape({}),
};

WhatsInTheBox.defaultProps = {
    className: '',
    loading: false,
    cards: [],
    nodeRef: null,
};

export default WhatsInTheBox;
